import React, { Component } from 'react';
import { connect } from 'react-redux';
import message from 'antd/lib/message';
import { selectAccount, selectCanUseTestTools } from '../../features/auth/ducks';
import toolRegistry from './toolRegistry';
import TestToolsLauncher from './TestToolsLauncher';
import CommandPalette from './CommandPalette';
import './test-tools.less';

const mapStateToProps = state => ({
  canUseTestTools: selectCanUseTestTools(state),
  account: selectAccount(state),
});

// Hide tools not meant for the logged-in role (e.g. top-up is creditor-only).
const toolsForRole = (tools, account) => tools.filter(
  tool => !tool.roles || (account && tool.roles.includes(account.role))
);

// Test tools ship disabled outside the dedicated dev build, so nothing here
// (not even the global hotkey listener) may run in production.
const isTestToolsEnabled = () => process.env.REACT_APP_TEST_TOOLS === 'true';

@connect(mapStateToProps)
export default class TestToolsPanel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      hidden: false,
    };
  }

  componentDidMount() {
    if (!isTestToolsEnabled()) {
      return;
    }

    window.addEventListener('keydown', this.onGlobalKey);
  }

  componentWillUnmount() {
    if (!isTestToolsEnabled()) {
      return;
    }

    window.removeEventListener('keydown', this.onGlobalKey);
  }

  onGlobalKey = (e) => {
    if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
      e.preventDefault();
      // Cmd/Ctrl+K reopens the tools and un-hides the launcher if it was hidden.
      this.setState(prevState => ({ open: !prevState.open, hidden: false }));
    }
  };

  openPalette = () => {
    this.setState({ open: true });
  };

  closePalette = () => {
    this.setState({ open: false });
  };

  hideLauncher = () => {
    this.setState({ hidden: true });
    message.info('Test Tools skryté — stlač ⌘K / Ctrl+K na znovuzobrazenie');
  };

  render() {
    if (!isTestToolsEnabled() || !this.props.canUseTestTools) {
      return null;
    }

    const { open, hidden } = this.state;
    const tools = toolsForRole(toolRegistry, this.props.account);

    return (
      <React.Fragment>
        {!hidden && (
          <TestToolsLauncher onOpen={this.openPalette} onHide={this.hideLauncher} />
        )}
        {open && (
          <CommandPalette
            tools={tools}
            onClose={this.closePalette}
          />
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/test-tools/TestToolsPanel.js